/**
 * form-api.js — Versand der Uhrinstinkt-Formulare an das AWS-Backend
 * (Zendesk-Ticket-Erstellung; E-Mail nur als Server-Fallback).
 *
 * Bedient alle <form data-api-form="contactForm|priceRequest">:
 * - Felder per name-Attribut: name, email, phone, message (+ Honeypot "website")
 * - Produktkontext bei priceRequest über data-product-* am <form>
 * - Erfolg: Overlay (data-success-overlay → FormKit.openOverlay) ODER
 *   Inline-Box [data-api-success] im umgebenden Container
 * - Fehler: [data-api-error]-Box im Formular einblenden
 *
 * Native Browser-Validierung bleibt aktiv (kein novalidate am <form>):
 * der submit-Handler feuert nur bei gültigen Feldern.
 */
(function () {
  'use strict';

  // Doppel-Einbindung (mehrere Sections laden das Script) → nur einmal binden
  if (window.__uhrFormApi) return;
  window.__uhrFormApi = true;

  var API_URL = 'https://onfsjc5l00.execute-api.eu-central-1.amazonaws.com/ankauf';

  function fieldValue(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function setLoading(form, loading) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.disabled = loading;
    if (loading) {
      btn.setAttribute('data-idle-label', btn.textContent);
      var l = btn.getAttribute('data-loading-label');
      if (l) btn.textContent = l;
    } else {
      var idle = btn.getAttribute('data-idle-label');
      if (idle) btn.textContent = idle;
    }
  }

  function toggleError(form, show) {
    var box = form.querySelector('[data-api-error]');
    if (!box) return;
    box.hidden = !show;
    if (show) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function showSuccess(form) {
    form.reset();
    var overlayId = form.getAttribute('data-success-overlay');
    if (overlayId && window.FormKit && window.FormKit.openOverlay) {
      window.FormKit.openOverlay(overlayId);
      return;
    }
    var wrap = form.parentElement;
    var box = wrap ? wrap.querySelector('[data-api-success]') : null;
    if (box) {
      form.hidden = true;
      box.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-api-form]') : null;
    if (!form) return;
    e.preventDefault();

    var action = form.getAttribute('data-api-form');
    var data = {
      locale: (document.documentElement.lang || 'de').slice(0, 2).toLowerCase(),
      name: fieldValue(form, 'name'),
      email: fieldValue(form, 'email'),
      phone: fieldValue(form, 'phone'),
      message: fieldValue(form, 'message'),
      website: fieldValue(form, 'hp_extra') // Honeypot (API-Key bleibt "website"); Feldname bewusst Autofill-fremd
    };
    if (action === 'priceRequest') {
      data.productTitle = form.getAttribute('data-product-title') || '';
      data.productReference = form.getAttribute('data-product-reference') || '';
      data.productSku = form.getAttribute('data-product-sku') || '';
      data.productUrl = form.getAttribute('data-product-url') || '';
    }

    setLoading(form, true);
    toggleError(form, false);

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: action, data: data })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function () { showSuccess(form); })
      .catch(function () { toggleError(form, true); })
      .finally(function () { setLoading(form, false); });
  });
})();
